/**
 * @description Hook utilizado para tratar da pesquisa no sistema
 * @author Diego Sabino Amorim de Araújo
 * @file useSearchService.js
 * @license Copyright (c) 2022 SIGEP DIGETI ITEP/RN
 */

import { useFetch } from './useFetch'

export const useSearchService = () => {
  const fetch = useFetch()

  const search = async (value, setSearchResponses, setProcessando) => {
    try {
      if (value) {
        if (setProcessando) setProcessando(true)
        const searchString = {
          searchString: value,
        }
        const response = await fetch.postOpenWithoutFeedback('/search/', searchString)
        if (response && response.data) {
          setSearchResponses(response.data.searchResponses)
        }
      }
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  return { search }
}
